<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        제출된 세부 사항
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
              <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">제출</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              WebShell 정보
            </div>
            <div class="mb7">
              <span class="float-right"> {{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="pth_title">
                주소
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div v-if="model && model.group_id" v-html="group_model.address"></div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="pth_title">
                회사명
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.group_id" v-html="group_model.groupname"></div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title">상태</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <!-- <div v-html="model.is_done ? '완료' : '대기'"></div> -->
              <b-badge :variant="model.is_done ? (model.is_alive ? (model.is_del ? 'danger' : 'success') : 'danger') : (model.is_del ? 'danger' : '-')">
                {{model.is_done ? (model.is_alive ? (model.is_del ? '삭제' : '승인') : '거절') : (model.is_del ? '삭제' : '-')}}
              </b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title">콘텐츠 타입</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-html="content_type"></div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title">파일 이름</label>
            </b-col>
            <b-col class="col-xl-10 col-md-12  d-flex align-self-center">
              <div v-html="model.filename"></div>
            </b-col>
          </b-row>
          <b-row v-if="model.is_done && !model.is_webshell">
            <b-col md="12">
              <b-form-group>
                <label for="ph_title">설명(이유)</label>
                <div v-html="model.description"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-12 col-md-12">
              <b-button class="float-right" size="sm" variant="warning" @click="decrypt" :disabled="decrypted">
                base64 강제 디코딩
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
            <b-form-group>
              <hr>
              <label for="ph_descript">내용</label>
              <div v-html="content || model.content || 'None'" style="padding:15px;background:#f5f5f5;border:1px solid #ccc;border-radius:5px;"></div>
            </b-form-group>
            </b-col>
          </b-row>
          <b-form>
            <!-- <a id="download" :href="model.content" :download="model.filename" :v-show="true" style="text-decoration:none;!important;">
              <b-button size="sm" variant="primary" style="margin:0 2px;">
                Download
              </b-button>
            </a> -->
            <b-button size="sm" variant="danger" style="margin:0 2px;" @click="approve_confrm = true;" :disabled="model.is_del">
              Webshell 등록
            </b-button>
            <b-button size="sm" variant="success" @click="reject_confirm = true" :disabled="model.is_del">
              위양성
            </b-button>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Webshell 등록"  class="modal-danger" v-model="approve_confrm" @ok="approve" ok-variant="outline-danger" ok-title="확인" cancel-variant="ouline-dark" cancel-title="취소" header-bg-variant="danger">
      등록하시겠습니까?
    </b-modal>
    <b-modal title="위양성"  class="modal-danger" v-model="reject_confirm" @ok="reject" ok-variant="outline-danger" ok-title="확인" cancel-variant="outline-dark" cancel-title="취소" header-bg-variant="danger">
      <b-form-group>
        <label for="ph_description">설명(이유)</label>
        <b-form-textarea :rows="3" v-model="model.description" id="ph_description"></b-form-textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>